import {
  PortalTooltip,
  PortalTooltipContent,
  PortalTooltipProvider,
  PortalTooltipTrigger,
} from "./portal-tooltip";

interface Props {
  children: React.ReactNode;
  component: React.ReactNode;
  listAlign?: "start" | "center" | "end";
  listSide?: "top" | "right" | "bottom" | "left";
}

export const ToolTipLists = ({
  component,
  children,
  listAlign,
  listSide,
}: Props) => {
  return (
    <PortalTooltipProvider>
      <PortalTooltip>
        <PortalTooltipTrigger asChild>{component}</PortalTooltipTrigger>
        <PortalTooltipContent align={listAlign} side={listSide}>
          <div className="min-w-max">{children}</div>
        </PortalTooltipContent>
      </PortalTooltip>
    </PortalTooltipProvider>
  );
};
